import { useCallback } from 'react';
import { useHttpFetchApi } from '../http/useHttpFetch';
import {
  UserAttribute,
  UserAttributeInputType
} from '../../models/UserAttribute';

export function useFindUserAttributes() {
  const { loading, error, getJson } = useHttpFetchApi();

  const findUserAttributes = useCallback(
    async (
      userId: number,
      type: string,
      source: string,
      sourceName?: string,
      inputType?: UserAttributeInputType,
      startDate?: string,
      endDate?: string,
      dateRange?: number
    ) => {
      return getJson<UserAttribute[]>(`users/${userId}/attributes`, {
        type,
        source,
        sourceName,
        utcOffset: new Date().getTimezoneOffset(),
        inputType,
        startDate,
        endDate,
        dateRange
      });
    },
    [getJson]
  );

  return {
    loadingUserAttributes: loading,
    userAttributesError: error,
    findUserAttributes
  };
}
